import { useAtom } from 'jotai';
import { authAtom } from '../atoms';
import { isSuperadmin } from '../lib/utils';

interface UseIsLoggedInProps {
  isAdmin: boolean;
}
export const useIsLoggedIn = (props: UseIsLoggedInProps = { isAdmin: false }) => {
  const [auth] = useAtom(authAtom);

  if (!auth?.user) return false;

  if (!props.isAdmin) return !!auth.user;

  return isSuperadmin(auth.user);
};
